import { STATUS_IDLE } from 'constants/statuses.constants';

export const getInitialState = () => ({
  constructs: [],
  insertSuggestions: [],
  suggestionsStatus: STATUS_IDLE,
  status: STATUS_IDLE,
  error: null,
});
